<template>
  <div>
    <div class="bb-departments bb-list">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <div class="bb-list-header" v-if="!departmentsTypes">
        <input
          class="bb-list-header__input bb-input"
          type="text"
          placeholder="New department"
          v-model="department.name"
          @keyup.enter="createDepartment()"/>
        <button class="bb-departments__btn bb-button" type="submit" @click="createDepartment()">Add</button>
      </div>
      <div class="bb-departments-list bb-list-body">

        <div class="bb-departments-list__item bb-list-body-item"
             v-for="(department, index) in departmentsList"
             :key="department.id"
             @mouseenter="chooseItem(index)"
             @mouseleave="leaveItem()">
          <input
            v-if="activeEditClick === index"
            class="bb-list-body-item__input-edit"
            v-model="editedDepartment.name"
            v-click-outside="hide"
            @keyup.enter="editDepartment(index, department.id)"
            v-autofocus>
          <transition name="fade-form">
            <button class="bb-list-body-item__btn-save bb-button"
                    v-if="activeEditClick === index"
                    @click="editDepartment(index, department.id)">
              Save
            </button>
          </transition>
          <span v-if="activeEditClick !== index" class="bb-list-body-item__title"> {{department.name}}</span>
          <transition name="fade-form" v-if="!department.type">
            <Toolbar v-if="activeIndex === index"
                     :delete-index="deleteConfirmIndex"
                     :index="index"
                     :item="department"
                     @deleteOpen="deleteConfirmIndex = index"
                     @deleteClose=" deleteConfirmIndex = false"
                     @openEdit="activateEditFunc"
                     @deleteItem="deleteDepartment"/>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import departmentsTypes from '@/constants/departmentsTypes'
import DepartmentsApi from '@/api/DepartmentsList/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import ClickOutside from 'vue-click-outside'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import {FOUNDER, CEO} from '@/constants/roles'

export default {
  name: 'SettingsDepartments',
  components: {
    LoaderFly,
    Toolbar
  },
  data () {
    return {
      departmentsTypes: departmentsTypes,
      loaderRun: false,
      activeIndex: false,
      deleteConfirmIndex: false,
      activeEditIndex: false,
      activeEditClick: false,
      editedDepartment: {
        name: ''
      }
    }
  },
  computed: {
    department () {
      return {
        name: '',
        company: this.activeCompany
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    departmentsList: {
      get () {
        return this.$store.getters.departmentsList
      },
      set (data) {
        this.$store.dispatch('setDepartmentsList', data)
      }
    },
    activeCompany () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    activateEditFunc (index, item) {
      this.editedDepartment.name = item.name
      this.activeEditIndex = index
      this.activeEditClick = index
    },
    createDepartment () {
      DepartmentsApi.createDepartment(this.department)
        .then((resp) => {
          this.departmentsList.unshift(resp.data)
          this.department.name = ''
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    editDepartment (index, id) {
      DepartmentsApi.editDepartment(this.editedDepartment, id)
        .then((resp) => {
          this.departmentsList.splice(index, 1, resp.data)
          this.activeEditIndex = false
          this.hide()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteDepartment (index, id) {
      DepartmentsApi.deleteDepartment(id)
        .then(() => {
          this.departmentsList.splice(index, 1)
          this.deleteConfirmIndex = false
        })
        .catch((err) => {
          console.error(err)
        })
    },
    chooseItem (index) {
      this.activeIndex = index
      this.activeEditIndex = index
    },
    leaveItem () {
      this.activeIndex = false
      this.deleteConfirmIndex = false
      this.activeEditIndex = false
    },
    getDepartments () {
      this.loaderRun = true
      DepartmentsApi.getDepartments()
        .then((resp) => {
          this.departmentsList = resp.data.departments
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    hide () {
      this.activeEditIndex = false
      this.activeEditClick = false
    }
  },
  watch: {
    activeCompany () {
      if (this.userInfo.role === FOUNDER.id || this.userInfo.role === CEO.id) {
        // this.getDepartments()
      }
    }
  },
  beforeMount () {
    // this.getDepartments()
    this.departmentsList = this.departmentsTypes
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-departments {
    max-width: 667px;

    &__btn {
      width: 73px;
      padding: 13px 23px;
      text-transform: uppercase;
    }

    &-list {
      margin-top: 30px;

      &__item {
        padding: 9px 23px 9px 12px;
        background-color: $color-white;

        &:hover {
          padding-left: 16px;
        }

        &:first-child {
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
        }

        &:last-child {
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/PositionsList/Departments/Departments.vue